import './_button.scss';

function Button({children, click}) {
  return (
    <button className="btn" onClick={click}>
        <span>
          {children}
        </span>
    </button>
  )
}

export default Button